import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface DevotionalSeries {
  id: string;
  title: string;
  subtitle?: string;
  description?: string;
  thumbnail?: string;
  date?: string;
  featured?: boolean;
  devotional_count?: number;
}

export const useDevotionalSeries = () => {
  return useQuery<DevotionalSeries[]>({
    queryKey: ['devotionalSeries'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('devotional_series')
        .select('id, title, subtitle, description, thumbnail, date, featured, devotionals(count)')
        .order('featured', { ascending: false })
        .order('date', { ascending: false })
        .limit(200);
      if (error) throw error;

      const series = (data ?? []).map((row: any) => ({
        id: row.id,
        title: row.title,
        subtitle: row.subtitle,
        description: row.description,
        thumbnail: row.thumbnail,
        date: row.date,
        featured: row.featured,
        devotional_count: row.devotionals?.[0]?.count ?? 0,
      })) as DevotionalSeries[];

      return series;
    },
    staleTime: 5 * 60_000,
  });
};
